import { List, ListItem, ListItemIcon, ListItemText, Fade, IconButton } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import MenuIcon from "@material-ui/icons/Menu";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import SubscriptionsIcon from "@material-ui/icons/Subscriptions";
import useStyles from "./style";
import { Link } from "react-router-dom";
import { useState } from "react";

export const Sidebar = () => {
    const styles = useStyles();
    let [active, setActive] = useState(true);

    return (
        <div>
            <IconButton onClick={e => { setActive(!active); }}>
                <MenuIcon />
            </IconButton>
            <Fade in={active} timeout={1000}>
                <List className={styles.root} component="nav" >
                    <ListItem button component={Link} to="/">
                        <ListItemIcon>
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Home" />
                    </ListItem>
                    <ListItem button component={Link} to="/Projects">
                        <ListItemIcon>
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Projects" />
                    </ListItem>
                </List >
            </Fade>
        </div >
    );
};
